export const SWAP_PROGRESS_STATUS = {
  SWAP_IN_PROGRESS: "in_progress",
  SWAP_COMPLETED: "swap_complete",
  SWAP_INCOMPLETE: "swap_incomplete",
  SWAP_PENDING: "swap_pending",
  SWAP_FAILED: "swap_failed",
  SWAP_ACTIVE: "swap_active",
  ERROR: "error",
};

export const EXPECTED_SWAP_STATUS = [
  "swap_complete",
  "swap_incomplete",
  "swap_pending",
];
